import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CancelAppointment } from 'components/CancelAppointment';
import { DownloadAppointmentPDF } from 'components/DownloadAppointmentPDF';
import { EditAppointment } from 'components/EditAppointment';
import { RateAppointment } from 'components/RateAppointment';
import { AppointmentsStatus, type Appointment } from 'types/appointments';
import { isDateTimePast } from 'utils/date';

export const TableActions = ({ appointment }: { appointment: Appointment }): React.ReactElement => {
  const { showDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const isAppointmentPast = isDateTimePast(appointment.dateTime, appointment.timeZone);

  return (
    <div className="flex gap-2">
      {appointment.sessionDetails?.type === AppointmentsStatus.FINISHED_SESSION && (
        <Button
          variant="secondary"
          onClick={() =>
            showDialog({
              component: <RateAppointment appointment={appointment} />,
            })
          }
        >
          <Star size={16} />
          {t('TableActions.rateSession.cta')}
        </Button>
      )}
      <DownloadAppointmentPDF appointment={appointment} icon="only" />
      {!isAppointmentPast && (
        <>
          <EditAppointment appointment={appointment} icon="only" />
          <CancelAppointment appointment={appointment} icon="only" />
        </>
      )}
    </div>
  );
};
